<template>
    <div class="companyprofile">
        <div class="bg">
            <img src="@imgs/gsjjbg.png" width="341px" height="93px" alt="" class="cpzx" />
        </div>
        <div class="companybrief">
            <div class="title">
                <div class="raio"></div>
                <span>公司简介</span>
                <div class="raio"></div>
            </div>
            <div class="content">
                <p>
                    企业简介：云南省药品科技开发经营有限公司成立于 1995 年，位于昆明高新区，注册资本 5080 万元，是云南深耕近三十年的老牌医药流通企业。公司拥有药品、三类医疗器械完整批发资质，严格执行
                    GSP 管理，主营中西药品、生物制品、医用耗材及保健食品等，主要服务省内药店、基层诊所及医疗机构，同步开展医药信息服务与数字化配套业务。
                </p>
                <!-- <p>
                    企业使命：创新驱动，让健康触手可及
                </p>
                <p>
                    企业愿景：成为医药大健康产业的引领者
                </p>
                <p>
                    核心价值观：责任诚信 创新开发 专业高效 共创共享
                </p> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            proList: [
                { id: 0, img: require('@imgs/pricer.png'), title: '西洋参' },
                { id: 1, img: require('@imgs/pricer.png'), title: '西洋参' },
                { id: 2, img: require('@imgs/pricer.png'), title: '西洋参' },
                { id: 3, img: require('@imgs/pricer.png'), title: '西洋参' },
                { id: 4, img: require('@imgs/pricer.png'), title: '西洋参' },
                { id: 5, img: require('@imgs/pricer.png'), title: '西洋参' },
                { id: 6, img: require('@imgs/pricer.png'), title: '西洋参' },
                { id: 7, img: require('@imgs/pricer.png'), title: '西洋参' },
                { id: 8, img: require('@imgs/pricer.png'), title: '西洋参' },
                { id: 9, img: require('@imgs/pricer.png'), title: '西洋参' },
                { id: 10, img: require('@imgs/pricer.png'), title: '西洋参' },
                { id: 11, img: require('@imgs/pricer.png'), title: '西洋参' },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.companyprofile {
    .companybrief {
        margin-top: 30px;

        .title {
            font-size: 22px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #fe2a1e;
            display: flex;
            justify-content: center;
            align-items: center;

            .raio {
                width: 6px;
                height: 6px;
                background: #fe2a1e;
                border-radius: 50%;
                display: inline-block;
            }

            span {
                margin: 0 7px;
            }
        }

        .content {
            width: 1187px;
            margin: 0 auto;
            margin-bottom: 30px;
            text-align: left;
            font-size: 18px;
            font-family: DengXian;
            color: #666666;
        }
    }
}
</style>
